import { useEffect, useRef, useState } from "react";
import useFetch from "../useFetch/useFetch";
import { getCampaignMissionProgressCount } from "@/services/campaign/campaign-progress-count/campaign-progress-count";
import { CampaignProgressCount } from "@/types/campaign/campaign-progress-count/campaign-progress-count-type";

export const useMissionProgress = (campaignId: string, userMainKey: string | null) => {
    const [progress, setProgress] = useState<CampaignProgressCount>({
        total_missions: 0,
        completed_missions: 0
    });

    const { data, loading, error, startFetch } = useFetch(
        getCampaignMissionProgressCount,
        { 
            user_main_key: userMainKey ?? undefined, 
            campaign_id: Number(campaignId) },
        { autoFetch: false }
    );

    const firstRender = useRef<boolean>(true);
    useEffect(() => {
        if (userMainKey && firstRender.current) {
            firstRender.current = false;
            startFetch();
        }
    }, [userMainKey, startFetch])


    useEffect(() => {
        if (data) {
            setProgress({
                total_missions: data.total_missions,
                completed_missions: data.completed_missions
            });
        }
    }, [data]);
    return { progress, loading, error };
};